import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import DayDragCalendar from '../../components/DayDragCalendar';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';

import messages from '../../locale/messages';
import updateStep3 from './updateStep3';

import stepCalendarIllustration from '/public/SiteImages/step-calendar.svg';

import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';
class Calendar extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    disabledDates: PropTypes.array,
    blockedDates: PropTypes.array,
  };

  static defaultProps = {
    listingSteps: {
      step3: "inactive",
      listing: {
        isPublished: false
      }
    },
    disabledDates: [],
    blockedDates: [],
    availableDatesPrices: [],
    availableDates: []
  };

  constructor(props) {
    super(props);
    this.state = {
      sources: [],
    };
  }


  componentDidMount() {
    const { listBlockedPrice } = this.props;
    let sources = [];
    let sourceObject = {};

    listBlockedPrice && listBlockedPrice.map((item, key) => {
      sourceObject = {};
      sourceObject["isSpecialPrice"] = item.isSpecialPrice;
      sourceObject["blockedDates"] = item.blockedDates;
      sources.push(sourceObject);
    });
    this.setState({ sources });

  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listBlockedPrice } = nextProps;
    let sources = [];
    let sourceObject = {};

    listBlockedPrice && listBlockedPrice.map((item, key) => {
      sourceObject = {};
      sourceObject["isSpecialPrice"] = item.isSpecialPrice;
      sourceObject["blockedDates"] = item.blockedDates;
      sources.push(sourceObject);
    });
    this.setState({ sources });

  }

  render() {
    const { formatMessage } = this.props.intl;
    const { error, handleSubmit, submitting, dispatch, nextPage, previousPage } = this.props;
    const { disabledDates, blockedDates, listId } = this.props;
    const { minNight, maxNight, houseRules, checkInEnd, checkInStart } = this.props;
    const { cancellationPolicy, maxDaysNotice, bookingNoticeTime, weeklyDiscount, monthlyDiscount } = this.props;
    const { availableDates, availableDatesPrices, baseCurrency, currency, availableCurrencies } = this.props;
    const { basePrice, cleaningPrice, formPage, step, tax, listingSteps } = this.props;

    const { sources } = this.state;
    const isPublished = listingSteps && listingSteps.listing && listingSteps.listing.isPublished;

    let isAdminCurrency;
    isAdminCurrency = availableCurrencies && availableCurrencies.find(o => o.isBaseCurrency == true)

    return (
      <div className={cx(s.eslipinBg, s.calendarScrollContainer)}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title=""
            highlightText={`Los toques finales \n para tener listo tu \n espacio`}
            subtitle=""
            iconImg={stepCalendarIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={s.stepRightCard}>
              <div className={s.landingMainContent}>
                <p className={cx(s.amenitiesSpacesTitle, s.spaceTop4)}>
                  <FormattedMessage {...messages.availability} />
                </p>
                <p className={s.bookingSpacesLabel}>
                  <FormattedMessage {...messages.calendar} />
                </p>
                <div className={s.lableWeight}>
                  {isPublished && (
                    <p className={cx(s.bookedWidth)}>
                      <span className={cx(s.notAvailableColor, 'availableRTl')}></span>
                      <FormattedMessage {...messages.booked} />
                    </p>
                  )}
                  <p className={s.calenderColorText}>
                    <span className={cx(s.bookedColor, 'availableRTl')}></span>
                    <FormattedMessage {...messages.notAvailable} />
                  </p>
                  <p className={s.calenderColorText}>
                    <span className={cx(s.availableColor, 'availableRTl')}></span>
                    <FormattedMessage {...messages.availableLabel} />
                  </p>
                  <p className={s.calenderColorText}>
                    <span className={cx(s.specialColor, 'availableRTl')}></span>
                    <FormattedMessage {...messages.sessionPrice} />
                  </p>
                </div>
                <FormGroup className={cx(s.formGroup, s.posRelative)}>
                  <DayDragCalendar
                    formName={"ListPlaceStep3"}
                    disabledDates={disabledDates}
                    blockedDates={blockedDates}
                    listId={listId}
                    availableDates={availableDates}
                    availableDatesPrices={availableDatesPrices}
                    sources={sources}
                    minNight={minNight}
                    maxNight={maxNight}
                    houseRules={houseRules}
                    checkInEnd={checkInEnd}
                    checkInStart={checkInStart}
                    cancellationPolicy={cancellationPolicy}
                    maxDaysNotice={maxDaysNotice}
                    bookingNoticeTime={bookingNoticeTime}
                    baseCurrency={baseCurrency}
                    currency={currency}
                    isAdminCurrency={isAdminCurrency}
                    basePrice={basePrice}
                    cleaningPrice={cleaningPrice}
                    tax={tax}
                    weeklyDiscount={weeklyDiscount}
                    monthlyDiscount={monthlyDiscount}
                    transitionDuration={0}
                    todayLabel={formatMessage(messages.todayLabel)}
                  />
                </FormGroup>
              </div>
              <FooterButton
                isDisabled={error}
                nextPage={nextPage}
                previousPage={previousPage}
                nextPagePath={"booking-scenarios"}
                previousPagePath={"advance-notice"}
                formPage={formPage}
                step={step}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

Calendar = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: updateStep3
})(Calendar);

// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep3'); // <-- same as form name

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  disabledDates: selector(state, 'disabledDates'),
  blockedDates: selector(state, 'blockedDates'),
  listBlockedPrice: selector(state, 'listBlockedPrice'),
  minNight: selector(state, 'minNight'),
  maxNight: selector(state, 'maxNight'),
  houseRules: selector(state, 'houseRules'),
  checkInStart: selector(state, 'checkInStart'),
  checkInEnd: selector(state, 'checkInEnd'),
  bookingNoticeTime: selector(state, 'bookingNoticeTime'),
  maxDaysNotice: selector(state, 'maxDaysNotice'),
  cancellationPolicy: selector(state, 'cancellationPolicy'),
  availableDates: selector(state, 'availableDates'),
  availableDatesPrices: selector(state, 'availableDatesPrices'),
  currency: selector(state, 'currency'),
  availableCurrencies: state?.currency?.availableCurrencies?.results,
  basePrice: selector(state, 'basePrice'),
  cleaningPrice: selector(state, 'cleaningPrice'),
  weeklyDiscount: selector(state, 'weeklyDiscount'),
  monthlyDiscount: selector(state, 'monthlyDiscount'),
  tax: selector(state, 'tax'),
  stepTwoDetails: state.calendar.stepTwoDetails,
  listingSteps: state.location.listingSteps
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Calendar)));
